// src/pages/Users/ArbitrageJudo/data/arbitrageJudoData.js

export const ARBITRAGE_SECTIONS = [
  {
    id: "role-arbitre",
    eyebrow: "Fondamentaux",
    title: "Rôle de l’arbitre",
    image: "/img/arbitrage/arbitrage_judo_01_zlmwhp.jpg",
    imageAlt: "Rôle de l'arbitre",
    layout: "text-left",
    intro:
      "L’arbitre garantit le bon déroulement du combat, la sécurité des judokas et l’application des règles.",
    bullets: [
      "Assurer la sécurité des combattants.",
      "Faire respecter les règles du judo.",
      "Attribuer les points et les pénalités.",
      "Déterminer le vainqueur du combat.",
    ],
  },
  {
    id: "commandes",
    eyebrow: "Gestes & annonces",
    title: "Les principales commandes de l’arbitre",
    image: "/img/arbitrage/arbitrage_judo_06_h2yqp4.jpg",
    imageAlt: "Gestes de l'arbitre",
    layout: "image-left",
    intro:
      "Les annonces de l’arbitre rythment le combat et permettent aux judokas, commissaires sportifs et spectateurs de suivre l’action.",
    items: [
      {
        title: "Hajime : début du combat",
        content:
          "Hajime est le terme japonais utilisé pour lancer le combat ou reprendre après une interruption.",
      },
      {
        title: "Matte : arrêt temporaire du combat",
        content:
          "Matte signifie que l’arbitre interrompt temporairement le combat. Les combattants doivent s’arrêter et reprendre leur position.",
      },
      {
        title: "Sore-made : fin du combat",
        content:
          "Sore-made indique la fin du combat. L’arbitre désigne ensuite le vainqueur.",
      },
      {
        title: "Osaekomi : début d’une immobilisation",
        content:
          "Osaekomi indique qu’une immobilisation est effective et que le chronomètre d’immobilisation est déclenché.",
      },
      {
        title: "Toketa : fin d’une immobilisation",
        content:
          "Toketa signifie que l’immobilisation est rompue. Le chronomètre d’immobilisation est arrêté.",
      },
    ],
  },
  {
    id: "scores",
    eyebrow: "Scores",
    title: "Points, avantages & pénalités",
    image: "/img/arbitrage/arbitrage_judo_04_o2hiap.webp",
    imageAlt: "Système de notation",
    layout: "text-left",
    intro:
      "Le système de notation permet d’évaluer les projections, les immobilisations, les abandons et les pénalités.",
    items: [
      {
        title: "Ippon : point complet",
        content:
          "Ippon est le score le plus élevé. Il donne la victoire immédiate. Il peut être accordé sur une projection avec force, vitesse et contrôle, une immobilisation maintenue 20 secondes, ou une soumission par clé de bras ou étranglement.",
      },
      {
        title: "Waza-ari : avantage fort",
        content:
          "Waza-ari est attribué lorsqu’une action est proche du ippon sans remplir toutes les conditions. Il peut aussi être obtenu par immobilisation entre 10 et 19 secondes. Deux waza-ari équivalent à ippon.",
      },
      {
        title: "Yuko : petit avantage",
        content:
          "Le yuko correspond à un petit avantage. Il peut être accordé pour certaines chutes ou immobilisations courtes selon les règlements appliqués.",
      },
      {
        title: "Shido & Hansoku-make",
        content:
          "Shido est une pénalité mineure. Trois shido entraînent hansoku-make, c’est-à-dire la disqualification et la victoire de l’adversaire.",
      },
    ],
  },
  {
    id: "regles-2025",
    eyebrow: "Évolution règlementaire",
    title: "Nouvelles règles d’arbitrage 2025",
    image: "/img/arbitrage/image_arbitrage01.jpg",
    imageAlt: "Nouvelles règles 2025",
    layout: "text-left",
    highlight: true,
    intro:
      "Quelques évolutions importantes à connaître pour mieux comprendre les décisions arbitrales.",
    bullets: [
      "Retour du yuko. En ne-waza, cette valeur peut être donnée au bout de cinq secondes d’immobilisation.",
      "L’utilisation de la tête pour projeter ou se défendre est à nouveau autorisée. Chez les cadets, cette action est pénalisée d’un shido.",
      "Toutes les saisies, dont celles à la veste sous la ceinture en haut de la cuisse intérieure, sont autorisées si elles ne sont pas utilisées de manière négative.",
      "Accrocher les jambes avec la main ou le bras en dessous du haut de la cuisse intérieure est sanctionné d’un shido.",
      "Une fois le kumikata installé, le combattant dispose de trente secondes pour lancer une attaque.",
      "La prise de l’ours est autorisée, mais si les bras ou les mains sont joints autour de l’adversaire, un shido est donné.",
      "Sortir de manière non intentionnelle de la surface de combat donne lieu à matte.",
      "Les clés de bras appliquées lors d’une projection avec risque élevé de blessure sont sanctionnées d’un hansoku-make.",
      "L’activité en ne-waza est prise en considération par le corps arbitral.",
      "Le seoi-nage inversé est à nouveau autorisé sauf chez les cadets, où il est pénalisé d’un shido.",
    ],
  },
  {
    id: "actions-interdites",
    eyebrow: "Sanctions",
    title: "Actions interdites & sanctions",
    image: "/img/arbitrage/arbitrage_judo_03_b1ibhn.jpg",
    imageAlt: "Actions interdites",
    layout: "image-left",
    intro:
      "Certaines actions sont sanctionnées pour protéger les judokas et préserver l’esprit du judo.",
    items: [
      {
        title: "Infractions légères : Shido",
        content: [
          "Éviter intentionnellement de prendre la saisie du kimono.",
          "Adopter une attitude défensive exagérée.",
          "Effectuer une fausse attaque sans réelle intention de projeter.",
          "Saisir en pistolet ou en ourlet le bout de la manche.",
          "Saisir les doigts ou le poignet trop longtemps pour empêcher le kumikata.",
          "Défaire volontairement son judogi ou sa ceinture.",
          "Insérer les doigts dans la manche ou le pantalon.",
          "Sortir volontairement de la zone de combat.",
          "Rompre la saisie adverse avec les deux mains ou tordre les doigts.",
          "Forcer l’adversaire à prendre une position courbée sans attaque immédiate.",
        ],
      },
      {
        title: "Infractions graves : Hansoku-make",
        content: [
          "Toute action mettant en danger l’intégrité physique de l’adversaire.",
          "Techniques illicites ou dangereuses.",
          "Soumissions interdites autres que sur l’articulation du coude.",
          "Actions contraires à l’esprit du judo : insultes, gestes déplacés, coups volontaires.",
          "Diving : projeter sa tête directement sur le tatami.",
          "Porter un objet dur ou garder un téléphone dans le judogi.",
        ],
      },
      {
        title: "Succession des Shido",
        content: [
          "Trois shido successifs entraînent hansoku-make.",
          "Un combattant peut reprendre la compétition après un hansoku-make causé par trois shido.",
          "Un hansoku-make pour action contraire à l’esprit du judo peut entraîner une exclusion de la compétition.",
        ],
      },
    ],
  },
  {
    id: "duree-combats",
    eyebrow: "Temps de combat",
    title: "La durée des combats",
    image: "/img/arbitrage/arbitrage_judo_07_mo5tqx.webp",
    imageAlt: "Durée des combats",
    layout: "text-left",
    intro:
      "La durée d’un combat varie selon la catégorie d’âge et le niveau de compétition.",
    items: [
      {
        title: "Temps de combat selon les catégories",
        content: [
          "Poussins et mini-poussins : 1 min 30.",
          "Benjamins : 2 min.",
          "Minimes, cadets-juniors-séniors 2D/3D : 3 min.",
          "Cadets 1D, juniors 1D, seniors 1D : 4 min.",
          "Temps de récupération : deux fois la durée du combat.",
        ],
      },
      {
        title: "Golden Score",
        content:
          "Le golden score est une prolongation utilisée lorsque le combat se termine sans vainqueur. Le premier judoka à marquer ou à bénéficier d’une pénalité donnée à l’adversaire remporte le combat.",
      },
    ],
  },
  {
    id: "table-arbitrage",
    eyebrow: "Compétition",
    title: "Table d’arbitrage & commissaires sportifs",
    image: "/img/arbitrage/arbitrage_judo_05_yce4cw.webp",
    imageAlt: "Table d'arbitrage",
    layout: "image-left",
    intro:
      "Les commissaires sportifs jouent un rôle essentiel dans le suivi du combat et la fiabilité des résultats.",
    items: [
      {
        title: "Scores, temps & résultats",
        content: [
          "Enregistrement des points : ippon, waza-ari et pénalités.",
          "Supervision du chronomètre de combat.",
          "Suivi des immobilisations au sol.",
          "Assistance à l’arbitre dans la confirmation des décisions.",
          "Annonce officielle du vainqueur après le combat.",
        ],
      },
      {
        title: "Importance de la table de marquage",
        content:
          "La table de marquage garantit une gestion équitable et transparente des combats. Les commissaires sportifs travaillent avec les arbitres pour appliquer les règles correctement.",
      },
    ],
  },
  {
    id: "formation",
    eyebrow: "Progression",
    title: "La formation des arbitres",
    image: "/img/arbitrage/arbitrage_judo_02_rpacmx.jpg",
    imageAlt: "Formation des arbitres",
    layout: "text-left",
    intro:
      "La formation des arbitres et commissaires sportifs est organisée progressivement, notamment par les écoles d’arbitrage des comités départementaux.",
    bullets: [
      "Découverte de l’arbitrage en club ou en département.",
      "Formation des commissaires sportifs.",
      "Écoles d’arbitrage départementales.",
      "Progression vers les niveaux départemental, régional, national puis international.",
    ],
  },
];